module.exports = __webpack_public_path__ + "static/media/battery-empty.1134f14c.svg";